import { PropsWithChildren } from "react";

import { ClientFileContext, ClientFileContextValue } from "./ClientFileContext";

export function ClientFileProvider({ value, children }: PropsWithChildren<{ value: ClientFileContextValue }>) {
  return <ClientFileContext.Provider value={value}>{children}</ClientFileContext.Provider>;
}
